// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__w+Vax","slick-next":"CustomSlider_slick-next__THI9t"};